(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(97682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37946);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  max-width: 130em;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f1d27b44-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 32980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37946);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62284);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52681);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13274);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 10rem;\n  padding-bottom: 4rem;\n  background: #FBF9ED;\n  color: ",
        ";\n  box-shadow: 0px 0px 0px #d3d3d3, 0px -1px 6px #d3d3d3;  \n  color:  #174F68;\n\n  h3 {\n    text-align: center;\n    margin-top: 5px;\n  }\n\n  .mobile-copyright {\n    display: none;\n  }\n\n  @media (max-width: 478px) {\n    h3 {\n      margin-top: 15px;\n    }\n    \n    .mobile-copyright {\n      display: inline-block;\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 150%;\n      margin-left: 85px;\n      }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  p {\n    margin-top: 3rem;\n    font-family: 'Nunito';\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n\n  }\n\n  img {\n    width: 90%;\n  }\n\n  @media (max-width: 600px) {\n    img {\n      margin-top: -5rem;\n      margin-bottom: 4rem;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  @media (max-width: 478px) {\n    p {\n      display: none;\n    }\n  }\n\n  p {\n    font-size: 14px !important;\n  }\n\n  @media (max-width: 820px) {\n    .mobile-copyright {\n      display: block;\n    }\n    .web-copyright {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {\n    width: 100%;\n    height: 85%;\n  }\n  \n  @media (max-width: 600px) {\n    \n    img {\n      margin-top: -5rem;\n      margin-bottom: 4rem;\n      width: 90%;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4rem;\n  margin-right: 5rem;\n\n  & > *:not(:first-child) {\n    margin-top: 1rem;\n  }\n  ",
        " {\n    flex: 40%;\n    margin-right: 1.5rem;\n  }\n  ",
        " {\n    margin-left: 6rem;\n    flex: 50% 50%;\n    margin-right: 0rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 1.6rem;\n  \n  a {\n    text-decoration: none;\n    \n    color: #174F68;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {  \n    width: 120px; \n    object-fit: contain;\n    padding-bottom: 1.5rem;\n  }\n  @media (max-width: 600px) {\n    img {\n      margin-bottom: 70px;\n    }\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    padding: 5rem;\n    flex-wrap: wrap;\n\n    width: 100%;\n    & > *:not(:first-child) {\n      margin-left: 1rem;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #174F68;\n\n  @media (max-width: 478px) {\n    font-size: 12px;\n    margin-top: 1rem;\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #174F68;\n\n  @media (max-width: 478px) {\n    font-size: 12px;\n    margin-top: 1rem;\n    display: block;\n    \n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var footerItems = [
    {
        title: "Como funciona",
        items: [
            {
                title: "Perguntas frequentes",
                href: "/faq"
            }
        ]
    },
    {
        title: "Contato",
        items: [
            {
                title: "Fale conosco",
                href: "/contact"
            }
        ]
    },
    {
        title: "Institucional",
        items: [
            {
                title: "Sobre n\xf3s",
                href: "/explore"
            },
            {
                title: "Termos de uso",
                href: "/termos-e-condicoes"
            },
            {
                title: "Pol\xedtica de privacidade",
                href: "/privacy-policy"
            }
        ]
    },
    {
        title: "Redes",
        items: [
            {
                title: "Instagram",
                href: "https://www.instagram.com/nossavaquinha/"
            }, 
        ]
    }, 
];
function Footer() {
    var user = (0,contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .a)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pathUrl = router.asPath;
    var isLogado = user.id && pathUrl !== "/" && pathUrl !== "/blog" && pathUrl !== "/about" && pathUrl !== "/faq" && pathUrl !== "/contact" ? true : false;
    var date = new Date();
    var year = date.getFullYear();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FooterWrapper, {
        colorTheme: "#4397c3",
        isLogado: isLogado,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListContainer, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Logo, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: "/Logo.svg",
                                        alt: "Selo Google",
                                        className: "google"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "web-copyright",
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " - Todos os direitos reservados."
                                        ]
                                    })
                                ]
                            }),
                            footerItems.map(function(singleItem) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, singleItem), singleItem.title);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Pag, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PaymentStickers, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/selo-google.svg",
                                            alt: "Selo Google",
                                            className: "google"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/selo-pagarme.svg",
                                            alt: "Selo Pagarme",
                                            className: "pagarme"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            src: "/selos-pagamento/ssl.svg",
                                            alt: "Selo SSL",
                                            className: "ssl"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LegalInfo, {
                        children: [
                            "Meu Nascimento Empreendimentos Ltda.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "CNPJ: 48.928.262/0001-47",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "Rua Jos\xe9 Versolato, 111 - S. Bernardo do Campo - SP"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MobileLegalInfo, {
                children: [
                    "Meu Nascimento Empreendimentos Ltda.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "CNPJ: 48.928.262/0001-47",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "Rua Jos\xe9 Versolato, 111 - S. Bernardo do Campo - SP"
                ]
            })
        ]
    });
}
function FooterList(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListHeader, {
                children: title
            }),
            items.map(function(singleItem) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, singleItem), singleItem.href);
            })
        ]
    });
}
function ListItem(param) {
    var title = param.title, href = param.href;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().pathname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItemWrapper, {
        colorTheme: "#4397c3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                href: "https://github.com",
                children: title
            })
        })
    });
}
var FooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-0"
})(_templateObject(), function(param) {
    var colorTheme = param.colorTheme;
    return colorTheme === "#fff6e8" ? "#4397c3" : "#fff";
});
var ListContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-1"
})(_templateObject1());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-2"
})(_templateObject2());
var Pag = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-3"
})(_templateObject3());
var ListHeader = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9a017512-4"
})(_templateObject4());
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-5"
})(_templateObject5(), (0,utils_media__WEBPACK_IMPORTED_MODULE_6__/* .media */ .B)("<=tablet"), (0,utils_media__WEBPACK_IMPORTED_MODULE_6__/* .media */ .B)("<=phone"));
var ListItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9a017512-6"
})(_templateObject6());
var PaymentStickers = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-7"
})(_templateObject7());
var LegalInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-8"
})(_templateObject8());
var MobileLegalInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a017512-9"
})(_templateObject9());


/***/ }),

/***/ 97682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Homepage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(37946);
// EXTERNAL MODULE: ./components/Seo.tsx + 2 modules
var Seo = __webpack_require__(57874);
// EXTERNAL MODULE: ./env.ts
var env = __webpack_require__(81431);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(32980);
// EXTERNAL MODULE: ./components/Pagination.tsx
var Pagination = __webpack_require__(56505);
// EXTERNAL MODULE: ./components/PoolCard.tsx
var PoolCard = __webpack_require__(91638);
// EXTERNAL MODULE: ./contexts/Loader.tsx
var Loader = __webpack_require__(41068);
// EXTERNAL MODULE: ./services/apiClient.ts
var apiClient = __webpack_require__(81372);
// EXTERNAL MODULE: ./components/Accordion.tsx + 1 modules
var Accordion = __webpack_require__(2597);
// EXTERNAL MODULE: ./utils/commomQuestions.ts
var commomQuestions = __webpack_require__(75319);
;// CONCATENATED MODULE: ./views/PricingPage/FaqSection2.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n  width: 80%;\n\n  & > *:not(:first-child) {\n   margin-top: 2rem;\n  }\n  \n  div {\n    color: #222222;\n    max-width: 1300px !important;\n\n    h3 {\n      border-bottom: 1px solid #fff;\n    }\n    \n    span {\n      width: 100%;\n      max-width: 1300px ;\n    }\n  }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent !important;\n  background: transparent;\n  color: #fff;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 15px 15px;\n  background: transparent; \n  color: #174F68;\n  cursor: pointer;\n  font-size: 2rem;\n  border: none;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin-left: 1.5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





function FaqSection() {
    var ref = (0,react.useState)(5), showQuestions = ref[0], setShowQuestions = ref[1];
    var handleLoadMore = function() {
        setShowQuestions(showQuestions + 5);
    };
    var handleLoadLess = function() {
        setShowQuestions(12);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            commomQuestions/* questions.slice */.X.slice(0, showQuestions).map(function(question) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemFaq, {
                    title: question.text,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: question.description ? question.description : ""
                        }
                    })
                }, question.id);
            }),
            showQuestions > 30 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoMessage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Caso n\xe3o tenha encontrado aqui a resposta "
                    }),
                    "adequada para a sua pergunta, entre em contato conosco, atrav\xe9s da aba “Contato” que fica no menu superior do site ou atrav\xe9s do nosso e-mail contato@nossavaquinha.com.br.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Descreva seu problema e sua pergunta. Ser\xe1 um prazer te ajudar!",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Atenciosamente,",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "~Equipe Nossa vaquinha."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoadList, {
                onClick: showQuestions < 30 ? handleLoadMore : handleLoadLess,
                children: showQuestions < 30 ? "Ver mais perguntas" : "Ver menos"
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70ee40c9-0"
})(_templateObject());
var ItemFaq = (0,styled_components_browser_esm/* default */.ZP)(Accordion/* default */.Z).withConfig({
    componentId: "sc-70ee40c9-1"
})(_templateObject1());
var ButtonLoadList = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-70ee40c9-2"
})(_templateObject2());
var InfoMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70ee40c9-3"
})(_templateObject3());

// EXTERNAL MODULE: ./components/Container.tsx
var Container = __webpack_require__(62284);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(13274);
;// CONCATENATED MODULE: ./components/OverTitle.tsx

function OverTitle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  &::before {\n    position: relative;\n    bottom: -0.1em;\n    content: '';\n    display: inline-block;\n    width: 0.9em;\n    height: 0.9em;\n    background-color: #174F68;\n    line-height: 0;\n    margin-right: 1em;\n  }\n\n  font-size: 1.3rem;\n  letter-spacing: 0.02em;\n  font-weight: bold;\n  line-height: 0;\n  text-transform: uppercase;\n\n  ",
        " {\n    line-height: 1.5;\n  }\n"
    ]);
    OverTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var OverTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a93ab168-0"
})(OverTitle_templateObject(), (0,media/* media */.B)("<=desktop"));
/* harmony default export */ var components_OverTitle = (OverTitle);

;// CONCATENATED MODULE: ./views/HomePage/Hero/HeroThree.tsx

function HeroThree_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 1rem;\n  margin-bottom: 8rem;\n  justify-content: center;\n  align-items:center;\n\n  ",
        " {\n    padding-top: 1rem;\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    HeroThree_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroThree_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  max-width: 70rem;\n\n  ",
        " {\n    max-width: 100%;\n  }\n"
    ]);
    HeroThree_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroThree_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: flex-end;\n  max-width: 100%;\n\n  img {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  svg {\n    max-width: 45rem;\n  }\n\n",
        " {\n  margin-top: 2rem;\n  justify-content: center;\n  svg {\n    max-width: 80%;\n  }\n}\n"
    ]);
    HeroThree_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroThree_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.8rem;\n  opacity: 0.8;\n  line-height: 1.6;\n  color: #174F68;\n\n  ",
        " {\n    font-size: 1.5rem;\n  }\n"
    ]);
    HeroThree_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  color: #174F68;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #174F68;\n  font-size:  5.2rem;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: 2rem;\n  letter-spacing: -0.03em;\n\n  ",
        " {\n    font-size: 4.6rem;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "./help.png",
                    alt: "friends"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contents, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomOverTitle, {
                        children: "Fa\xe7a a sua vaquinha"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: "Quem ajuda uma m\xe3e, ajuda toda uma fam\xedlia! "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                        children: [
                            "Pensando nisso, a Nossa Vaquinha criou uma plataforma de doa\xe7\xe3o com ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "TAXA ZERO PARA M\xc3ES"
                            }),
                            " criarem suas campanhas, seja por uma causa emergencial, seja para dar mais conforto e condi\xe7\xf5es para seus filhos."
                        ]
                    })
                ]
            })
        ]
    });
}
var HeroWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-8b20e660-0"
})(HeroThree_templateObject(), (0,media/* media */.B)("<=desktop"));
var Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b20e660-1"
})(HeroThree_templateObject1(), (0,media/* media */.B)("<=desktop"));
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b20e660-2"
})(HeroThree_templateObject2(), (0,media/* media */.B)("<=desktop"));
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8b20e660-3"
})(HeroThree_templateObject3(), (0,media/* media */.B)("<=desktop"));
var CustomOverTitle = (0,styled_components_browser_esm/* default */.ZP)(components_OverTitle).withConfig({
    componentId: "sc-8b20e660-4"
})(_templateObject4());
var Heading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8b20e660-5"
})(_templateObject5(), (0,media/* media */.B)("<=tablet"));

// EXTERNAL MODULE: ./components/FilterPoolCard.tsx
var FilterPoolCard = __webpack_require__(7802);
;// CONCATENATED MODULE: ./views/HomePage/Header.tsx

function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.7rem;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background: #FBF9ED;\n\n  width: ",
        ";\n  margin: ",
        "; \n\n  box-shadow: ",
        ";\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  margin-top: ",
        "; \n  transition: all 0.3s ease;\n  position: ",
        ";\n  top: 0;\n  left: 300;\n  z-index: 999;\n\n  img {\n\n    transition: transform 0.3s ease; \n\n    :hover {\n      transform: scale(1.3); /* Aumenta a escala em 20% no hover */\n    }\n  }\n\n  @media (min-width: 768px) {\n   width: ",
        ";\n   #search-icon {\n     display: none;\n   }\n  }\n\n  @media (max-width: 768px) {\n    width: ",
        ";\n    #faq {\n      display: none;\n    }\n  }\n\n  @media (min-width: 1268px) { //\n    width: ",
        ";\n   }\n\n   @media (min-width: 1668px) {\n    width: ",
        ";\n   }\n\n   @media (min-width: 1768px) {\n    width: ",
        ";\n   }\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #000;\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    max-width: 115px;\n  }\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  transition: opacity 0.4s;\n\n  :hover {\n    opacity: 0.8;\n  }\n\n  background: #174F68;\n  width: 100px;\n  height: 33px;\n  border-radius: 10px;\n  font-weight: 800;\n\n  text-decoration: none;\n  font-size: 1.7rem;\n  color: #fff;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    position: absolute;\n    justify-content: center;\n    gap: 4rem;\n    align-items: center;\n    top: 40px;\n    left: 40px;\n    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);\n    border-radius: 15px;\n    height: 45vh;\n    width: 70vw;\n    background-color: #FBF9ED;\n    padding: 1rem;\n    opacity: ",
        ";\n    visibility: ",
        ";\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n\n    a {\n      display: block;\n      text-align: right;\n    }\n  }\n"
    ]);
    Header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #174F68;\n  text-decoration: none;\n  font-size: 1.5rem;\n\n  transition: opacity 0.4s;\n\n  :hover {\n    opacity: 0.5;\n    text-decoration: none;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 2rem;\n  }\n"
    ]);
    Header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 24px;\n  height: 19px;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    display: flex;\n  }\n\n  span {\n    width: 100%;\n    height: 2px;\n    background-color: #333333;\n    transition: transform 0.3s ease;\n\n    &:first-child {\n      transform: ",
        ";\n    }\n\n    &:nth-child(2) {\n      opacity: ",
        ";\n    }\n\n    &:last-child {\n      transform: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var HeaderContainer = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-d9461b1d-0"
})(Header_templateObject(), function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "auto" : "140%";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "20px auto";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "80px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "80px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "80px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "80px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "20px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "fixed" : "fixed";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "100%" : "85%";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "100%" : "95%";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "100%" : "70%";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "100%" : "70%";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "100%" : "70%";
});
var Header_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9461b1d-1"
})(Header_templateObject1());
var Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9461b1d-2"
})(Header_templateObject2());
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d9461b1d-3"
})(Header_templateObject3());
var Nav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-d9461b1d-4"
})(Header_templateObject4(), function(param) {
    var open = param.open;
    return open ? "1" : "0";
}, function(param) {
    var open = param.open;
    return open ? "visible" : "hidden";
});
var NavItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-d9461b1d-5"
})(Header_templateObject5());
var HamburgerIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9461b1d-6"
})(_templateObject6(), function(param) {
    var open = param.open;
    return open ? "rotate(45deg) translate(7px, 5px)" : "none";
}, function(param) {
    var open = param.open;
    return open ? "0" : "1";
}, function(param) {
    var open = param.open;
    return open ? "rotate(-45deg) translate(7px, -5px)" : "none";
});
var Header = function() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), scrolled = ref1[0], setScrolled = ref1[1];
    var ref2 = (0,react.useState)(false), isMobile = ref2[0], setIsMobile = ref2[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };
        var checkIsMobile = function() {
            return window.matchMedia("(max-width: 768px)").matches;
        };
        setIsMobile(checkIsMobile());
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var handleHamburgerClick = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
            scrolled: scrolled,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "/explore",
                    id: "search-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/search.svg",
                        alt: "search"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "/faq",
                    id: "faq",
                    children: "Como funciona"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                    open: isOpen,
                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                href: "/contact",
                                children: "Contato"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                href: "/explore",
                                children: "Campanhas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                href: "/faq",
                                children: "Como funciona"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/login",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: "Entrar"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                href: "/contact",
                                children: "Contato"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/Logo.svg",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                href: "/explore",
                                children: "Campanhas"
                            })
                        ]
                    })
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/Logo.svg",
                        alt: ""
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/login",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        style: {
                            cursor: "pointer"
                        },
                        children: "Entrar"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamburgerIcon, {
                    open: isOpen,
                    onClick: handleHamburgerClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_Header = (Header);

;// CONCATENATED MODULE: ./components/FooterScrool.tsx

function FooterScrool_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  height: 12%;\n  width: 100%;\n  background-color: #FBF9ED;\n  color: #fff;\n  transform: translateY(100%);\n  transition: transform 0.3s ease;\n  box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.1);\n  \n  a {\n    text-decoration:none; \n  }\n\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &.show {\n    transform: translateY(0);\n  }\n\n  z-index: 99999;\n"
    ]);
    FooterScrool_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FooterScrool_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #174F68;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.5rem;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n\n  margin-top: 25px;\n"
    ]);
    FooterScrool_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var FooterContainer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-7ac796ae-0"
})(FooterScrool_templateObject());
var FooterScrool_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7ac796ae-1"
})(FooterScrool_templateObject1());
var ScrollToTopButton = function() {
    var ref = (0,react.useState)(false), showFooter = ref[0], setShowFooter = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var footer = document.getElementById("footer");
            if (footer && scrollTop > window.innerHeight) {
                footer.classList.add("show");
                setShowFooter(true);
            } else if (footer) {
                footer.classList.remove("show");
                setShowFooter(false);
            }
        };
        var checkIsMobile = function() {
            return window.matchMedia("(max-width: 768px)").matches;
        };
        if (checkIsMobile()) {
            window.addEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        id: "footer",
        className: showFooter ? "show" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/login",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterScrool_Button, {
                    children: "Criar uma campanha"
                })
            })
        })
    });
};
/* harmony default export */ var FooterScrool = (ScrollToTopButton);

;// CONCATENATED MODULE: ./components/Pig.tsx

function Pig_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 40%;\n  transform: translateX(-50%);\n  width: 250px; \n\n  @media (max-width: 768px) {\n    left: 47%;\n    width: 210px; \n  }\n"
    ]);
    Pig_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Pig_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  left: 41%;\n  transform: translateX(-50%);\n  width: 80px; \n\n  transition: top 0.5s ease, opacity 0.5s ease-in-out; \n  opacity: ",
        "; \n\n  @media (max-width: 768px) {\n    left: 53%;\n    width: 70px;\n  }\n"
    ]);
    Pig_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Pig_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 380px; \n  position: absolute;\n  left: 50%;\n  top: 0;\n\n  @media (max-width: 768px) {\n    width: 250px; \n    position: relative; \n    left: 40px;\n    transform: none;\n    top: 180px; \n  }\n"
    ]);
    Pig_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var PigImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-701152b9-0"
})(Pig_templateObject());
var CoinsImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-701152b9-1"
})(Pig_templateObject1(), function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "50px" : "-60px";
}, function(param) {
    var scrolled = param.scrolled;
    return scrolled ? "0" : "1";
});
var TextLogoImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-701152b9-2"
})(Pig_templateObject2());
var PiggyBank = function() {
    var ref = (0,react.useState)(false), scrolled = ref[0], setScrolled = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative",
            height: "100px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PigImage, {
                src: "/Porco1.png",
                alt: "Porquinho"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinsImage, {
                scrolled: scrolled,
                src: "/moeda.png",
                alt: "Moedas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLogoImage, {
                src: "/text-logo.png",
                alt: "Outra Imagem"
            })
        ]
    });
};
/* harmony default export */ var Pig = (PiggyBank);

// EXTERNAL MODULE: ./contexts/AuthContext.tsx + 1 modules
var AuthContext = __webpack_require__(52681);
// EXTERNAL MODULE: ./views/PricingPage/FaqVideosSection.tsx
var FaqVideosSection = __webpack_require__(62257);
;// CONCATENATED MODULE: ./views/HomePage/HomePageDefault.tsx



function HomePageDefault_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    HomePageDefault_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-display: swap;\n\n  @media (max-width: 500px) {\n    max-width: 100vw;\n  }\n"
    ]);
    HomePageDefault_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  margin-top: -30px;\n  margin-bottom: 10px;\n\n  color: #fff;\n  text-align: center;\n  font-family: Nunito;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 58px; /* 161.111% */\n"
    ]);
    HomePageDefault_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  div {\n    width: 100%;\n    height: auto;\n  }\n"
    ]);
    HomePageDefault_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  max-width: 130em;\n  margin: 54px auto;\n\n  a,\n  a:visited,\n  a:active {\n    text-decoration: none !important;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    HomePageDefault_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  background-image: url('/pool/home-header-bg.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  min-height: 730px;\n  margin-bottom: 69px;\n  flex-direction: column;\n  row-gap: 20px;\n\n  margin-top: 4.5rem;\n\n  & > div {\n    :first-child {\n      color: #174f68;\n      text-align: center;\n      font-family: 'Nunito';\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 64px;\n    }\n  }\n\n  @media (max-width: 1090px) {\n    flex-direction: column-reverse;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n    margin-top: -4.3rem;\n  }\n"
    ]);
    HomePageDefault_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HomePageDefault_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n\n  @media (min-width: 1068px) {\n    margin-left: 150px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 3rem;\n  }\n"
    ]);
    HomePageDefault_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 100%;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (max-width: 768px) {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 8rem;\n  color: #174f68;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 700px;\n  }\n\n  background-image: linear-gradient(to left, #ef4444, #174f68, #ef4444);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n\n  div {\n    margin-top: -5rem;\n  }\n  a {\n    background: #174f68;\n    font-size: 1.5rem;\n    padding: 1.3rem;\n    border-radius: 10px;\n    text-decoration: none;\n    color: #fff;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 4rem;\n\n    img {\n      width: 300px;\n    }\n\n    div {\n      margin-top: 4px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5rem;\n  color: #555;\n  margin-bottom: 15px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 25px;\n  background-color: #174f68;\n  color: white;\n  border: none;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  font-size: 15px;\n\n  &:hover {\n    opacity: 0.9;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 800px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #174f68;\n  flex-direction: column;\n\n  h1 {\n    color: #fff;\n    font-weight: 700;\n    font-size: 4rem;\n    margin-bottom: 6rem;\n  }\n\n  @media (max-width: 768px) {\n    height: 150%;\n    margin-top: 9rem;\n\n    h1 {\n      margin: 5rem;\n    }\n  }\n\n  border-top-left-radius: 50% 7%;\n  border-top-right-radius: 50% 7%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7rem;\n  margin-bottom: 4rem;\n  justify-content: center;\n  align-items: center;\n  max-width: 70%;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    margin-bottom: 5rem;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fbf9ed;\n  border-radius: 20px;\n  height: 165px;\n  width: 300px;\n  flex-basis: calc(33.3% - 5rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1rem;\n\n  p {\n    font-size: 16px;\n  }\n\n  img {\n    position: relative;\n    left: 0;\n    top: -30px;\n    max-width: 50%;\n    height: auto;\n  }\n\n  @media (max-width: 768px) {\n    flex-basis: 20%;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: auto;\n  top: 50px;\n  left: 0;\n  display: none;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    top: -300px;\n    left: 0;\n  }\n\n  @media (max-width: 768px) {\n    ",
        " {\n      top: 0px;\n      display: block;\n    }\n    img {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: #fbd5d3;\n  align-items: center;\n  justify-content: center;\n  padding: 150px 150px;\n  position: relative;\n\n  h2 {\n    font-family: 'P22 Mackinac Pro';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 120%;\n    text-align: center;\n    color: #ffffff;\n\n    @media (max-width: 478px) {\n      padding: 20px;\n      text-align: center;\n    }\n  }\n\n  @media (max-width: 778px) {\n    padding: 150px 10px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: #fbd5d3;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 40px 0px;\n  position: relative;\n\n  h2 {\n    font-family: 'P22 Mackinac Pro';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 35px;\n    line-height: 120%;\n    text-align: center;\n    color: #ffffff;\n    text-shadow: 0 0 10px rgba(0, 0, 0, 0.174);\n\n    @media (max-width: 478px) {\n      padding: 20px;\n      text-align: center;\n    }\n  }\n\n  p {\n    font-size: 17px;\n    color: #ffffff;\n    text-shadow: 0 0 10px rgba(0, 0, 0, 0.166);\n  }\n\n  @media (max-width: 778px) {\n    padding: 50px 10px 0px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #9edcf8;\n\n  h1 {\n    color: #fff;\n    font-weight: 700;\n    font-size: 4rem;\n  }\n\n  p {\n    color: #fff;\n  }\n\n  button {\n    margin-top: 30rem;\n    background: #174f68;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1.5rem;\n    color: #fff;\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  a {\n    color: #174f68;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    font-size: 2rem;\n  }\n\n  & > div {\n    align-self: center;\n    text-align: center;\n\n    :first-child {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      max-width: 500px;\n\n      & h1:first-child {\n        color: #174f68;\n        text-align: center;\n        font-family: 'Nunito';\n        font-size: 26px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 64px;\n        line-height: 40px;\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fbf9ed;\n\n  margin-bottom: 8rem;\n\n  h1 {\n    color: #174f68;\n    font-weight: 700;\n    font-size: 4rem;\n    margin-bottom: 6rem;\n    margin-top: 8rem;\n  }\n\n  @media (max-width: 768px) {\n    h1 {\n      margin-bottom: 6rem;\n    }\n\n    margin-bottom: 9rem;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4rem;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    height: 100%;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fbf9ed;\n  border-radius: 10px;\n  height: 250px;\n  width: 390px;\n  flex-basis: calc(30% - 0.1rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1rem;\n\n  h2 {\n    font-size: 20px;\n    margin-bottom: 1rem;\n    color: #174f68;\n  }\n\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n\n  p {\n    font-size: 18px;\n    color: #656b8a;\n  }\n\n  img {\n    position: relative;\n    left: 0;\n    top: -30px;\n    max-width: 80%;\n    height: auto;\n  }\n\n  @media (max-width: 768px) {\n    width: 300px;\n    flex-basis: 10%;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  margin: 20px 0;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    top: -100px;\n    left: 0;\n    z-index: 999999;\n  }\n\n  @media (max-width: 768px) {\n    img {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fbf9ed;\n\n  margin-top: 5rem;\n\n  @media (max-width: 768px) {\n    margin-top: 200px;\n  }\n\n  margin-bottom: 20rem;\n\n  a {\n    color: #fff;\n    background: #174f68;\n    text-decoration: none;\n    padding: 1rem;\n    font-size: 18px;\n    border-radius: 6px;\n\n    margin-top: -4rem;\n    margin-bottom: 4rem;\n\n    transition: opacity 0.3s ease;\n  }\n\n  a:hover {\n    opacity: 0.8;\n  }\n\n  h1 {\n    color: #174f68;\n    font-weight: 700;\n    font-size: 4rem;\n    margin-bottom: 6rem;\n    margin-top: 8rem;\n\n    strong {\n      color: #f19392;\n    }\n  }\n\n  @media (max-width: 768px) {\n    h1 {\n      font-size: 3rem;\n      margin-bottom: 6rem;\n    }\n\n    margin-bottom: 9rem;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    height: 100%;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fbf9ed;\n  border-radius: 10px;\n  height: 380px;\n  width: 350px;\n  flex-basis: calc(20% - 0.1rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  div {\n    background: red;\n    width: 100%;\n  }\n\n  h2 {\n    font-size: 25px;\n    margin-bottom: 1rem;\n    color: #174f68;\n  }\n\n  h3 {\n    font-size: 15px;\n    color: #174f68;\n    margin: 10px;\n  }\n\n  :nth-child(1) {\n    h2,\n    p {\n      color: #67bea4;\n    }\n\n    // box-shadow: 10px 10px 20px 10px rgba(105, 190, 164, 0.2);\n  }\n\n  :nth-child(2) {\n    h2,\n    p {\n      color: #ffc100;\n    }\n    // box-shadow: 10px 2px 10px rgba(60, 146, 193, 0.2);\n  }\n\n  :nth-child(3) {\n    h2,\n    p {\n      color: #f19392;\n    }\n    // box-shadow: 10px 2px 10px rgba(241, 147, 146, 0.2);\n  }\n\n  :nth-child(4) {\n    h2,\n    p {\n      color: #3c92c1;\n    }\n    // box-shadow: 10px 2px 10px rgba(255, 193, 0, 0.2);\n  }\n\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n\n  p {\n    font-size: 15px;\n    color: #174f68;\n\n    font-weight: 900;\n  }\n\n  img {\n    position: relative;\n    left: 0;\n    top: 0;\n    max-width: 80%;\n    height: auto;\n  }\n\n  @media (max-width: 768px) {\n    flex-basis: 10%;\n    width: 300px;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 200px;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fbf9ed;\n\n  margin-bottom: 8rem;\n\n  h3 {\n    margin-top: 2rem;\n    margin: 0.1rem;\n    font-size: 2rem;\n    color: hsl(210, 8%, 43.54%);\n  }\n\n  h1 {\n    color: #174f68;\n    font-weight: 700;\n    font-size: 4rem;\n    margin-bottom: 2rem;\n    margin-top: -6rem;\n  }\n\n  @media (max-width: 768px) {\n    margin-top: 300px;\n\n    h1 {\n      margin-bottom: 6rem;\n      font-size: 3rem;\n    }\n\n    margin-bottom: 9rem;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #174f68;\n  font-weight: 700;\n  font-size: 4rem;\n  margin-bottom: 2rem;\n  margin-top: -6rem;\n\n  \n  @media (max-width: 768px) {\n    margin-bottom: 6rem;\n    font-size: 24px;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n    gap: 7rem;\n    height: 100%;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fbf9ed;\n  border-radius: 10px;\n  height: 350px;\n  width: 400px;\n  flex-basis: calc(23% - 0.1rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n\n  p {\n    margin-top: 1.5rem;\n    font-size: 18px;\n    color: #656b8a;\n    width: 85%;\n  }\n\n  img {\n    position: relative;\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40%;\n    height: auto;\n  }\n\n  @media (max-width: 768px) {\n    margin-top: -1rem;\n    width: 300px;\n    flex-basis: 10%;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  border-radius: 10px;\n  flex-direction: column;\n\n  h1 {\n    font-size: 2.5rem;\n    color: #ffffff;\n  }\n\n  ",
        ":nth-child(1) & {\n    background: #4397c3;\n  }\n\n  ",
        ":nth-child(2) & {\n    background: #f09192;\n  }\n\n  ",
        ":nth-child(3) & {\n    background: #8b8ee8;\n  }\n\n  ",
        ":nth-child(4) & {\n    background: #5cc9aa;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 8rem;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 99;\n  padding: 15px 45px;\n  border-radius: 8px;\n  text-transform: uppercase;\n  border: none;\n  font-family: 'Nunito';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 110%;\n  margin-top: 20px;\n  background-color: #174F68;\n  width: 100%;\n  max-width: 415px;\n  color: #fff;\n  cursor: pointer;\n\n  & > a {\n    font-family: Nunito;\n    font-weight: 700;\n    line-height: 20px;\n    text-align: center;\n  }\n\n  @media (max-width: 478px) {\n    margin-right: 0;\n    margin-bottom: 30px;\n    font-size: 14px !important;\n    width: 90%;\n  }\n\n  a {\n    color: #FBF9ED !important;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}


















var useHomePageDefaultState = function() {
    var ref = (0,react.useState)(), filter = ref[0], setFilter = ref[1];
    var ref1 = (0,react.useState)([]), pools = ref1[0], setPools = ref1[1];
    var setLoader = (0,Loader/* useLoader */.U)().setLoader;
    var ref2 = (0,react.useState)(0), totalPools = ref2[0], setTotalPools = ref2[1];
    var ref3 = (0,react.useState)(0), totalPoolPages = ref3[0], setTotalPoolPages = ref3[1];
    var ref4 = (0,react.useState)(1), currentPage = ref4[0], setCurrentPage = ref4[1];
    var getPoolsWithFilter = (0,react.useCallback)(function(page) {
        setLoader === null || setLoader === void 0 ? void 0 : setLoader(true);
        apiClient/* api.post */.h.post("/pools/_search/?limit=3&page=".concat(page), filter ? {
            category_id: filter.categoryId,
            state: filter.state,
            period: filter.period
        } : undefined).then(function(param) {
            var data = param.data;
            var ref;
            var ref1;
            var mappedPools = (ref1 = (ref = data.values) === null || ref === void 0 ? void 0 : ref.map(function(pool) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pool), {
                    active: pool.status !== "finished"
                });
            })) !== null && ref1 !== void 0 ? ref1 : [];
            setPools(mappedPools);
            var _total;
            setTotalPools((_total = data.total) !== null && _total !== void 0 ? _total : 0);
            setCurrentPage(page);
            setTotalPoolPages(data.pages);
        }).finally(function() {
            setLoader === null || setLoader === void 0 ? void 0 : setLoader(false);
        });
    }, [
        setLoader,
        filter
    ]);
    (0,react.useEffect)(function() {
        getPoolsWithFilter(currentPage);
    }, [
        currentPage,
        getPoolsWithFilter
    ]);
    var handleCleanFilter = (0,react.useCallback)(function() {
        setFilter(undefined);
    }, []);
    var handleNextPage = (0,react.useCallback)(function() {
        var next = currentPage + 1;
        if (totalPools >= next) getPoolsWithFilter(next);
    }, [
        currentPage,
        getPoolsWithFilter,
        totalPools
    ]);
    var handlePreviewPage = (0,react.useCallback)(function() {
        var preview = currentPage - 1;
        if (totalPools > preview) getPoolsWithFilter(preview);
    }, [
        currentPage,
        getPoolsWithFilter,
        totalPools
    ]);
    var handleOnFilter = (0,react.useCallback)(function(filter) {
        setFilter((0,_object_spread/* default */.Z)({}, filter));
        getPoolsWithFilter(1);
    }, [
        getPoolsWithFilter
    ]);
    return {
        totalPoolPages: totalPoolPages,
        totalPools: totalPools,
        pools: pools,
        currentPage: currentPage,
        getPoolsWithFilter: getPoolsWithFilter,
        handleCleanFilter: handleCleanFilter,
        handleNextPage: handleNextPage,
        handlePreviewPage: handlePreviewPage,
        handleOnFilter: handleOnFilter
    };
};
function HomePageDefault() {
    var ref = useHomePageDefaultState(), totalPoolPages = ref.totalPoolPages, currentPage = ref.currentPage, pools = ref.pools, handleNextPage = ref.handleNextPage, handlePreviewPage = ref.handlePreviewPage, handleOnFilter = ref.handleOnFilter, getPoolsWithFilter = ref.getPoolsWithFilter;
    var user = (0,AuthContext/* useAuth */.a)().user;
    var ref1 = (0,react.useState)(false), isAuthenticated = ref1[0], setIsAuthenticated = ref1[1];
    (0,react.useEffect)(function() {
        setIsAuthenticated(!!(user === null || user === void 0 ? void 0 : user.email));
    }, [
        isAuthenticated,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroOne, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                            src: "/especial.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageMobile, {
                            src: "/especialMobile2.png",
                            alt: "Mobile Image"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pig, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterScrool, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTree, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleSectionTree, {
                                children: "Voc\xea m\xe3e, n\xe3o est\xe1 sozinha!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainerSectionTree, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTree, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Img, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/heart.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    "Criar campanha ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " Gr\xe1tis"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Plataforma segura"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Suas doa\xe7\xf5es s\xe3o protegidas por tecnologia de seguran\xe7a do Banco Stone."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTree, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Img, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/hands.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    "Personalizar site ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Gr\xe1tis"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Edi\xe7\xe3o f\xe1cil e criativa"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Ferramentas exclusivas para deixar o site da campanha do seu jeito."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTree, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Img, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/people.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    "Taxa Nossa Vaquinha ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "0%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "M\xe3es n\xe3o pagam!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Demais benefici\xe1rios pagam apenas R$ 1,00 por doa\xe7\xe3o. Leia os Termos de Uso."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTree, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Img, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/hands2.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                children: [
                                                    "Tarifa de saque ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "R$ 3,67"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Pague uma \xfanica vez"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Sugerimos aguardar receber todas as doa\xe7\xf5es para pagar R$ 3,67 uma \xfanica vez."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: !isAuthenticated ? "/login" : "/profile/user",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCreate, {
                        children: "Criar Vaquinha Gr\xe1tis"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "./line.svg",
                        alt: "linhas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondImage, {
                        src: "./linha.png",
                        alt: "Segunda Imagem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPoolCard/* default */.Z, {
                    onSearch: handleOnFilter
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionPool, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolGrid, {
                        children: pools.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(item.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/".concat(item.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard/* default */.Z, {
                                            data: item
                                        })
                                    })
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        onPress: getPoolsWithFilter,
                        currentPage: currentPage,
                        totalPages: totalPoolPages,
                        onNextPage: handleNextPage,
                        onPreviewPage: handlePreviewPage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTwo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Como funciona"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainerTwo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTwo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/1.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Crie sua conta gratuitamente. \xc9 bem simples e seguro: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/login",
                                                children: "clique aqui"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "M\xe3es e OSC s\xe3o isentos de taxas percentuais. Os demais benefici\xe1rios (n\xe3o m\xe3es) pagam apenas R$ 1,00 por doa\xe7\xe3o."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTwo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/2.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Personalize gr\xe1tis seu site de campanha com as cores que desejar e uma imagem de capa. Voc\xea possui tamb\xe9m espa\xe7o para v\xeddeo, \xe1lbum de fotos e um mural de mensagens de incentivo.\xa0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTwo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/3.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "\xa0Conte sua hist\xf3ria e defina qual valor voc\xea precisa. Publique nas suas redes sociais e receba as doa\xe7\xf5es com seguran\xe7a em sua conta-corrente. \xa0"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: !isAuthenticated ? "/login" : "/profile/user",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCreate, {
                        children: "Criar Campanha Gr\xe1tis"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "./line.svg",
                        alt: "linhas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondImage, {
                        src: "./linha.png",
                        alt: "Segunda Imagem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowWorks, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Como Funciona?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqVideosSection/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonQuestions, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Perguntas Frequentes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
}
var Animation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-0"
})(HomePageDefault_templateObject());
var MainContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-a172da91-1"
})(HomePageDefault_templateObject1());
var Circle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a172da91-2"
})(HomePageDefault_templateObject2(), function(param) {
    var background = param.background;
    return background;
});
var HeroOne = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-a172da91-3"
})(HomePageDefault_templateObject3());
var PoolGrid = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-a172da91-4"
})(HomePageDefault_templateObject4(), (0,media/* media */.B)("<=tablet"), (0,media/* media */.B)("<=phone"));
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-a172da91-5"
})(HomePageDefault_templateObject5());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-6"
})(HomePageDefault_templateObject6());
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a172da91-7"
})(_templateObject7());
var ImageMobile = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a172da91-8"
})(_templateObject8());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-a172da91-9"
})(_templateObject9());
var HomePageDefault_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a172da91-10"
})(_templateObject10());
var HomePageDefault_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a172da91-11"
})(_templateObject11());
var Sectiongreen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-12"
})(_templateObject12());
var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-13"
})(_templateObject13());
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-14"
})(_templateObject14());
var SecondImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a172da91-15"
})(_templateObject15());
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-16"
})(_templateObject16(), SecondImage);
var CommonQuestions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-17"
})(_templateObject17());
var HowWorks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-18"
})(_templateObject18());
var SectiongreenTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-19"
})(_templateObject19());
var SectionPool = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-20"
})(_templateObject20());
var SectionTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-21"
})(_templateObject21());
var CardContainerTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-22"
})(_templateObject22());
var CardTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-23"
})(_templateObject23());
var LineTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-24"
})(_templateObject24());
//-----------------
var SectionPromotion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-25"
})(_templateObject25());
var Promotion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-26"
})(_templateObject26());
var CardPromotion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-27"
})(_templateObject27());
var SectionTree = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-28"
})(_templateObject28());
var SubtitleSectionTree = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a172da91-29"
})(_templateObject29());
var CardContainerSectionTree = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-30"
})(_templateObject30());
var CardTree = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-31"
})(_templateObject31());
var Img = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-32"
})(_templateObject32(), CardTree, CardTree, CardTree, CardTree);
var ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172da91-33"
})(_templateObject33());
var ButtonCreate = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a172da91-34"
})(_templateObject34());

;// CONCATENATED MODULE: ./pages/index.tsx


function pages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #FBF9ED;\n  font-display: swap;\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var __N_SSG = true;
function Homepage(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* SEO */.H, {
                title: "".concat(env/* EnvVars.SITE_NAME */.$.SITE_NAME, " - Taxa Zero para M\xe3es"),
                description: "Vaquinha.",
                excludeTitleSuffix: true,
                image: "".concat(env/* EnvVars.URL */.$.URL, "/logo.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteBackgroundContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageDefault, {})
            })
        ]
    });
}
var WhiteBackgroundContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b6cba5a-0"
})(pages_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,134,2364,9786,9694,3669,5690,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);